interface GetBannerGTMParams {
  index: number
  pos?: string
  adUnit?: string
}
export const getBannerGTMAdsAnalyticsInfo = ({
  index,
  pos = 'TOP',
  adUnit,
}: GetBannerGTMParams) => {
  return {
    banner_position: adUnit ? `${adUnit}|${pos}|${index}` : null,
    banner_url: null,
  }
}

interface GetBannerAnalyticsParams {
  clientId: string
  pagetype: string
  category?: {
    name?: string
    id?: string
  }
  index: number
  banner?: {
    targetUrl?: {
      url: string
    }
    targetUrlInfo?: {
      url: string
    }
  }
}
export const getBannerAnalyticsInfo = ({
  clientId,
  pagetype,
  category = {},
  index,
  banner,
}: GetBannerAnalyticsParams) => {
  const path = category?.name ? `/${category.name.replace(/\s/g, '-')}` : null
  return {
    banner_position: banner ? `${clientId}/${pagetype}${path}|${index}` : null,
    banner_url: banner?.targetUrl?.url || banner?.targetUrlInfo?.url || null,
  }
}
